import { Controller } from "@hotwired/stimulus"

// Live docs search. Debounces typing and re-submits the search form so the
// results Turbo frame refreshes without a full page load (the input keeps
// focus). Only attached on the docs search results page, where the frame
// exists; elsewhere the search box does a normal navigation.
export default class extends Controller {
  static values = { delay: { type: Number, default: 250 } }

  debouncedSubmit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
